module.exports = __webpack_public_path__ + "static/img/apple-touch-icon-ipad-retina-152x152.31ea78f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-touch-icon-ipad-retina-152x152.png
// module id = 420
// module chunks = 1